export function value(value, defaultValue) {
    if (!value) {
        return defaultValue;
    }
    return value;
}
export function values(value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = []; }
    if (!value) {
        return defaultValue;
    }
    return value.filter(function (v) { return !!v; });
}
//# sourceMappingURL=maybe.js.map